
import { Label } from "@/components/ui/label";
import { OptimizedWeightSelector } from "../../../OptimizedWeightSelector";

interface WeightFieldProps {
  value: number;
  onChange: (value: string) => void;
  exerciseId: string;
  setIndex: number;
}

export const WeightField = ({ 
  value, 
  onChange, 
  exerciseId, 
  setIndex
}: WeightFieldProps) => {
  return (
    <div className="space-y-2">
      <Label className="text-sm text-gray-200">
        Peso
      </Label>
      <OptimizedWeightSelector
        value={value}
        onChange={onChange}
        exerciseId={exerciseId}
        setIndex={setIndex}
        isPersonalPlan={true}
      />
    </div>
  );
};
